module.exports = __webpack_public_path__ + "static/media/other_files.f02eb163.svg";